var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.183,
    height: 107.279,
    viewBox: "0 0 97.183 107.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86148",
    "data-name": "Rect\\xE1ngulo 86148",
    width: 97.183,
    height: 107.279,
    fill: "#e0e8f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18008",
    "data-name": "Grupo 18008",
    transform: "translate(-635.117 -355.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17887",
    "data-name": "Grupo 17887",
    transform: "translate(635.117 355.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107046",
    "data-name": "Trazado 107046",
    d: "M30.071,162.576l-1.416,1.047.06,1.761-1.434-1.023-1.656.6.53-1.68-1.084-1.389,1.761-.015.986-1.46.559,1.671Z",
    transform: "translate(-18.113 -118.943)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107047",
    "data-name": "Trazado 107047",
    d: "M35.421,169.5l4.313,2.336-4.718-1.341Z",
    transform: "translate(-25.298 -125.6)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107048",
    "data-name": "Trazado 107048",
    d: "M70.454,68.074l-1.5.106-.762,1.295-.564-1.393-1.467-.325,1.15-.967-.144-1.5,1.275.8,1.378-.6-.362,1.458Z",
    transform: "translate(-47.799 -47.172)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107049",
    "data-name": "Trazado 107049",
    d: "M74.328,73.225l2.036,3.656-2.782-3.125Z",
    transform: "translate(-53.159 -54.276)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17886",
    "data-name": "Grupo 17886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17885",
    "data-name": "Grupo 17885",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107050",
    "data-name": "Trazado 107050",
    d: "M4.076,116.907l3.272,2.183-3.505-1.84a.2.2,0,0,1-.083-.276.226.226,0,0,1,.3-.078l.02.012",
    transform: "translate(-2.696 -86.557)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107051",
    "data-name": "Trazado 107051",
    d: "M103.088,179.786l5.471,3.487-5.7-3.145a.2.2,0,0,1-.077-.278.226.226,0,0,1,.3-.072l.012.007",
    transform: "translate(-74.23 -133.129)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107052",
    "data-name": "Trazado 107052",
    d: "M20.208,127.151l1.349,1.041-1.582-.7a.2.2,0,0,1-.1-.272.225.225,0,0,1,.291-.1.218.218,0,0,1,.046.027",
    transform: "translate(-14.341 -94.137)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107053",
    "data-name": "Trazado 107053",
    d: "M85.219,168.436l1.349,1.041-1.582-.7a.2.2,0,0,1-.1-.272.226.226,0,0,1,.291-.1.219.219,0,0,1,.046.027",
    transform: "translate(-61.308 -124.714)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107054",
    "data-name": "Trazado 107054",
    d: "M93.634,173.782l1.349,1.041-1.582-.7a.2.2,0,0,1-.1-.272.226.226,0,0,1,.291-.1.231.231,0,0,1,.046.027",
    transform: "translate(-67.387 -128.673)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107055",
    "data-name": "Trazado 107055",
    d: "M29.177,132.847,43.9,141.825,28.944,133.19a.2.2,0,0,1-.07-.279.225.225,0,0,1,.3-.066l0,0",
    transform: "translate(-20.836 -98.366)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107056",
    "data-name": "Trazado 107056",
    d: "M88.267,203.9l6.6.473-6.622-.067a.2.2,0,1,1,0-.406h.014",
    transform: "translate(-63.599 -151.01)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107057",
    "data-name": "Trazado 107057",
    d: "M67.121,202.97l1.725.273-1.744.132a.214.214,0,0,1-.236-.187.209.209,0,0,1,.2-.22.235.235,0,0,1,.054,0",
    transform: "translate(-48.307 -150.323)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107058",
    "data-name": "Trazado 107058",
    d: "M77.08,203.4l1.725.274-1.744.132a.214.214,0,0,1-.236-.187.209.209,0,0,1,.2-.22.233.233,0,0,1,.054,0",
    transform: "translate(-55.502 -150.644)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107059",
    "data-name": "Trazado 107059",
    d: "M.794,200.078,18.344,201l-17.57-.514a.209.209,0,0,1-.21-.209.212.212,0,0,1,.223-.2H.794",
    transform: "translate(-0.408 -148.183)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107060",
    "data-name": "Trazado 107060",
    d: "M76.442,30.112l1.638,3.431L76.055,30.3a.2.2,0,0,1,.079-.278.226.226,0,0,1,.3.073l.011.02",
    transform: "translate(-54.925 -22.213)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107061",
    "data-name": "Trazado 107061",
    d: "M129.952,134.485l2.826,5.6-3.213-5.412a.2.2,0,0,1,.085-.276.225.225,0,0,1,.3.079l.006.012",
    transform: "translate(-93.585 -99.517)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107062",
    "data-name": "Trazado 107062",
    d: "M85.159,47.118l.6,1.536L84.772,47.3a.2.2,0,0,1,.058-.284.228.228,0,0,1,.3.054.211.211,0,0,1,.025.045",
    transform: "translate(-61.217 -34.797)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107063",
    "data-name": "Trazado 107063",
    d: "M120.293,115.648l.6,1.536-.985-1.351a.2.2,0,0,1,.058-.284.229.229,0,0,1,.3.054.207.207,0,0,1,.025.045",
    transform: "translate(-86.599 -85.553)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107064",
    "data-name": "Trazado 107064",
    d: "M124.842,124.52l.6,1.536-.985-1.351a.2.2,0,0,1,.058-.284.228.228,0,0,1,.3.054.208.208,0,0,1,.025.045",
    transform: "translate(-89.886 -92.123)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107065",
    "data-name": "Trazado 107065",
    d: "M90.007,56.574l7.826,14.709L89.621,56.759a.2.2,0,0,1,.091-.274.225.225,0,0,1,.293.084l0,0",
    transform: "translate(-64.728 -41.817)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107066",
    "data-name": "Trazado 107066",
    d: "M47.248,105.062l1.119,1.257-1.415-.961a.2.2,0,0,1-.049-.286.229.229,0,0,1,.306-.045.213.213,0,0,1,.04.034",
    transform: "translate(-33.855 -77.757)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107067",
    "data-name": "Trazado 107067",
    d: "M55,112.329l20,18.081-20.3-17.787a.194.194,0,0,1-.01-.287.228.228,0,0,1,.307-.009l0,0",
    transform: "translate(-39.472 -83.152)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107068",
    "data-name": "Trazado 107068",
    d: "M85.276,88.294l.759,1.473-1.124-1.253a.2.2,0,0,1,.027-.288.229.229,0,0,1,.308.025.2.2,0,0,1,.029.043",
    transform: "translate(-61.307 -65.307)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107069",
    "data-name": "Trazado 107069",
    d: "M91.037,97.211l5.228,7.635-5.588-7.408a.2.2,0,0,1,.052-.283.227.227,0,0,1,.3.049l.006.008",
    transform: "translate(-65.481 -71.928)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107070",
    "data-name": "Trazado 107070",
    d: "M148.164,69.206l3.824,18.741-4.25-18.661a.2.2,0,0,1,.167-.241.218.218,0,0,1,.258.156v0",
    transform: "translate(-106.73 -51.134)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107071",
    "data-name": "Trazado 107071",
    d: "M111.751,56.523l.465,1.576-.866-1.42a.2.2,0,0,1,.082-.279.227.227,0,0,1,.3.076.2.2,0,0,1,.021.047",
    transform: "translate(-80.424 -41.751)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107072",
    "data-name": "Trazado 107072",
    d: "M115.832,66.339,124.6,87.473l-9.172-20.984a.2.2,0,0,1,.119-.264.223.223,0,0,1,.283.111v0",
    transform: "translate(-83.38 -49.037)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107073",
    "data-name": "Trazado 107073",
    d: "M54.771,178.348l1.543.771-1.7-.392a.2.2,0,0,1-.16-.247.22.22,0,0,1,.265-.149.246.246,0,0,1,.051.018",
    transform: "translate(-39.337 -132.072)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107074",
    "data-name": "Trazado 107074",
    d: "M64.678,182.158l9.04,3.287-9.188-2.906a.2.2,0,0,1-.136-.257.221.221,0,0,1,.275-.127l.009,0",
    transform: "translate(-46.513 -134.901)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107075",
    "data-name": "Trazado 107075",
    d: "M37.4,107.04a.788.788,0,1,1-.787-.735.762.762,0,0,1,.787.735",
    transform: "translate(-25.885 -78.732)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107076",
    "data-name": "Trazado 107076",
    d: "M134.511,67.733a.788.788,0,1,1-.786-.735.762.762,0,0,1,.786.735",
    transform: "translate(-96.041 -49.621)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107077",
    "data-name": "Trazado 107077",
    d: "M35.384,94.087a.518.518,0,1,1-.517-.483.5.5,0,0,1,.517.483",
    transform: "translate(-24.816 -69.326)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107078",
    "data-name": "Trazado 107078",
    d: "M127.272,58.758a.518.518,0,1,1-.517-.483.5.5,0,0,1,.517.483",
    transform: "translate(-91.201 -43.16)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107079",
    "data-name": "Trazado 107079",
    d: "M23.2,153.085a.494.494,0,0,1-.467.526.508.508,0,0,1-.563-.437.494.494,0,0,1,.467-.526.509.509,0,0,1,.563.437",
    transform: "translate(-16.016 -113.054)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107080",
    "data-name": "Trazado 107080",
    d: "M78.436,104.462a.518.518,0,1,1-.517-.483.5.5,0,0,1,.517.483",
    transform: "translate(-55.919 -77.01)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107081",
    "data-name": "Trazado 107081",
    d: "M84.871,116l5.37,5.779-5.69-5.5a.194.194,0,0,1,.005-.287.228.228,0,0,1,.307,0l.008.008",
    transform: "translate(-61.04 -85.862)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107082",
    "data-name": "Trazado 107082",
    d: "M295.786,170.841l1.343,1.064-.177,1.638,1.5-.865,1.612.663-.417-1.6,1.173-1.228-1.756-.123-.887-1.422-.669,1.523Z",
    transform: "translate(-213.691 -125.143)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107083",
    "data-name": "Trazado 107083",
    d: "M291.025,178.881l-4.8.958,4.459-1.91Z",
    transform: "translate(-206.785 -131.779)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107084",
    "data-name": "Trazado 107084",
    d: "M263.14,69.426l1.5.1.762,1.21.564-1.3,1.467-.3-1.15-.9.144-1.4-1.275.743-1.378-.56.363,1.362Z",
    transform: "translate(-190.106 -49.495)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107085",
    "data-name": "Trazado 107085",
    d: "M263.943,75.256l-2.782,2.92L263.2,74.76Z",
    transform: "translate(-188.676 -55.369)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107086",
    "data-name": "Trazado 107086",
    d: "M338.936,123.363,335.318,125l3.408-1.993a.226.226,0,0,1,.3.064.2.2,0,0,1-.069.28l-.021.011",
    transform: "translate(-242.25 -91.08)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107087",
    "data-name": "Trazado 107087",
    d: "M230.375,180.126l-5.9,2.816,5.687-3.171a.226.226,0,0,1,.3.07.2.2,0,0,1-.075.278l-.012.006",
    transform: "translate(-162.174 -133.122)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107088",
    "data-name": "Trazado 107088",
    d: "M327.363,132.611l-1.624.608,1.414-.963a.229.229,0,0,1,.306.045.2.2,0,0,1-.048.285.22.22,0,0,1-.047.025",
    transform: "translate(-235.33 -97.923)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107089",
    "data-name": "Trazado 107089",
    d: "M259.97,169.881l-1.624.608,1.414-.963a.229.229,0,0,1,.306.045.2.2,0,0,1-.048.285.222.222,0,0,1-.047.025",
    transform: "translate(-186.642 -125.527)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107090",
    "data-name": "Trazado 107090",
    d: "M251.247,174.7l-1.624.608,1.414-.963a.229.229,0,0,1,.306.045.2.2,0,0,1-.048.285.221.221,0,0,1-.047.025",
    transform: "translate(-180.34 -129.099)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107091",
    "data-name": "Trazado 107091",
    d: "M282.044,137.754l-15.487,7.772,15.277-8.127a.226.226,0,0,1,.3.076.2.2,0,0,1-.081.277l0,0",
    transform: "translate(-192.574 -101.742)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107092",
    "data-name": "Trazado 107092",
    d: "M263.363,31.831l-2.025,3.246,1.638-3.431a.224.224,0,0,1,.287-.1.2.2,0,0,1,.11.268l-.011.019",
    transform: "translate(-188.804 -23.349)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107093",
    "data-name": "Trazado 107093",
    d: "M206.767,136.2l-3.212,5.412,2.826-5.6a.224.224,0,0,1,.289-.1.2.2,0,0,1,.1.27l-.006.012",
    transform: "translate(-147.058 -100.654)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107094",
    "data-name": "Trazado 107094",
    d: "M257.33,48.837l-.985,1.351.6-1.536a.224.224,0,0,1,.28-.122.2.2,0,0,1,.131.262.21.21,0,0,1-.025.045",
    transform: "translate(-185.196 -35.933)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107095",
    "data-name": "Trazado 107095",
    d: "M222.2,117.368l-.985,1.351.6-1.536a.224.224,0,0,1,.281-.122.2.2,0,0,1,.106.307",
    transform: "translate(-159.814 -86.689)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107096",
    "data-name": "Trazado 107096",
    d: "M217.649,126.239l-.985,1.351.6-1.536a.224.224,0,0,1,.281-.122.2.2,0,0,1,.106.307",
    transform: "translate(-156.529 -93.259)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107097",
    "data-name": "Trazado 107097",
    d: "M233.7,58.292l-8.212,14.525,7.826-14.71a.224.224,0,0,1,.291-.091.2.2,0,0,1,.1.272l0,0",
    transform: "translate(-162.907 -42.952)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107098",
    "data-name": "Trazado 107098",
    d: "M172.143.209l-.118,3.755L171.709.219a.208.208,0,0,1,.2-.218.213.213,0,0,1,.234.187.191.191,0,0,1,0,.022",
    transform: "translate(-124.051 0)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107099",
    "data-name": "Trazado 107099",
    d: "M175.016,117.463l-.055,6.188-.379-6.179a.209.209,0,0,1,.2-.214.212.212,0,0,1,.229.191s0,.009,0,.013",
    transform: "translate(-126.127 -86.845)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107100",
    "data-name": "Trazado 107100",
    d: "M172.608,19.313l-.174,1.627-.26-1.617a.207.207,0,0,1,.184-.232.217.217,0,0,1,.249.172.192.192,0,0,1,0,.051",
    transform: "translate(-124.385 -14.137)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107101",
    "data-name": "Trazado 107101",
    d: "M174.494,96.3l-.174,1.627-.26-1.617a.207.207,0,0,1,.184-.232.217.217,0,0,1,.249.172.194.194,0,0,1,0,.051",
    transform: "translate(-125.748 -71.157)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107102",
    "data-name": "Trazado 107102",
    d: "M174.739,106.268l-.174,1.627-.26-1.617a.207.207,0,0,1,.184-.232.217.217,0,0,1,.249.172.209.209,0,0,1,0,.051",
    transform: "translate(-125.925 -78.539)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107103",
    "data-name": "Trazado 107103",
    d: "M172.872,29.935l.214,16.426-.648-16.416a.209.209,0,0,1,.209-.21.211.211,0,0,1,.225.2v.005",
    transform: "translate(-124.577 -22.022)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107104",
    "data-name": "Trazado 107104",
    d: "M293.9,106.891l-1.415.961L293.6,106.6a.229.229,0,0,1,.308-.026.2.2,0,0,1,.029.288.24.24,0,0,1-.039.034",
    transform: "translate(-211.303 -78.893)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107105",
    "data-name": "Trazado 107105",
    d: "M237.033,114.157l-20.3,17.787,20-18.081a.228.228,0,0,1,.307,0,.193.193,0,0,1,0,.287l0,0",
    transform: "translate(-156.576 -84.288)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107106",
    "data-name": "Trazado 107106",
    d: "M256.8,90.048,255.671,91.3l.759-1.473a.226.226,0,0,1,.292-.1.2.2,0,0,1,.1.273.2.2,0,0,1-.029.043",
    transform: "translate(-184.709 -66.444)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107107",
    "data-name": "Trazado 107107",
    d: "M239.44,98.971l-5.588,7.408,5.228-7.635a.226.226,0,0,1,.3-.061.2.2,0,0,1,.066.28l-.006.008",
    transform: "translate(-168.946 -73.064)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107108",
    "data-name": "Trazado 107108",
    d: "M187.979,52.888,181.7,76.2l5.854-23.4a.218.218,0,0,1,.261-.151.2.2,0,0,1,.162.244v0",
    transform: "translate(-131.271 -38.984)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107109",
    "data-name": "Trazado 107109",
    d: "M228.48,57.175l-.866,1.421.465-1.576a.221.221,0,0,1,.269-.142.2.2,0,0,1,.153.251.208.208,0,0,1-.021.047",
    transform: "translate(-164.44 -42.119)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107110",
    "data-name": "Trazado 107110",
    d: "M202.814,66.986,193.642,87.97l8.769-21.134a.222.222,0,0,1,.281-.116.2.2,0,0,1,.124.262v0",
    transform: "translate(-139.897 -49.405)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107111",
    "data-name": "Trazado 107111",
    d: "M278.589,185.892l-1.723.286,1.594-.674a.226.226,0,0,1,.29.1.2.2,0,0,1-.109.271.255.255,0,0,1-.052.015",
    transform: "translate(-200.022 -137.376)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107112",
    "data-name": "Trazado 107112",
    d: "M248.576,189.038l-9.374,2.329,9.253-2.719a.221.221,0,0,1,.272.133.2.2,0,0,1-.142.254l-.009,0",
    transform: "translate(-172.811 -139.711)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107113",
    "data-name": "Trazado 107113",
    d: "M303.269,108.574a.788.788,0,1,0,.787-.735.762.762,0,0,0-.787.735",
    transform: "translate(-219.097 -79.869)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107114",
    "data-name": "Trazado 107114",
    d: "M203.327,43.12a.788.788,0,1,0,.787-.735.762.762,0,0,0-.787.735",
    transform: "translate(-146.893 -31.391)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107115",
    "data-name": "Trazado 107115",
    d: "M306.689,95.622a.518.518,0,1,0,.517-.483.5.5,0,0,0-.517.483",
    transform: "translate(-221.567 -70.463)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107116",
    "data-name": "Trazado 107116",
    d: "M207.131,32.829a.518.518,0,1,0,.517-.483.5.5,0,0,0-.517.483",
    transform: "translate(-149.642 -23.956)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107117",
    "data-name": "Trazado 107117",
    d: "M313.847,162.343a.488.488,0,0,0,.429.553.514.514,0,0,0,.593-.4.489.489,0,0,0-.429-.554.514.514,0,0,0-.592.4",
    transform: "translate(-226.734 -119.934)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107118",
    "data-name": "Trazado 107118",
    d: "M263.637,106a.519.519,0,1,0,.517-.483.5.5,0,0,0-.517.483",
    transform: "translate(-190.464 -78.147)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107119",
    "data-name": "Trazado 107119",
    d: "M245.245,117.81l-5.69,5.5,5.37-5.779a.227.227,0,0,1,.306-.02.194.194,0,0,1,.021.286l-.008.008",
    transform: "translate(-173.066 -86.998)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107120",
    "data-name": "Trazado 107120",
    d: "M267.866,334.563l1.5-.1.763-1.21.563,1.3,1.467.3-1.15.9.144,1.4-1.275-.743-1.378.56.362-1.362Z",
    transform: "translate(-193.519 -246.817)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107121",
    "data-name": "Trazado 107121",
    d: "M267.922,330.63l-2.035-3.416,2.782,2.92Z",
    transform: "translate(-192.09 -242.343)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107122",
    "data-name": "Trazado 107122",
    d: "M340.1,285.112l-3.4-2.011,3.608,1.657a.2.2,0,0,1,.1.272.224.224,0,0,1-.291.093l-.02-.011",
    transform: "translate(-243.255 -209.672)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107123",
    "data-name": "Trazado 107123",
    d: "M231.879,224.389l-5.668-3.2,5.88,2.847a.2.2,0,0,1,.093.273.225.225,0,0,1-.293.087l-.012-.006",
    transform: "translate(-163.426 -163.819)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107124",
    "data-name": "Trazado 107124",
    d: "M328.568,278.72l-1.409-.97,1.621.616a.2.2,0,0,1,.12.266.225.225,0,0,1-.285.112.227.227,0,0,1-.047-.025",
    transform: "translate(-236.356 -205.709)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107125",
    "data-name": "Trazado 107125",
    d: "M261.382,241.076l-1.408-.97,1.621.616a.2.2,0,0,1,.12.266.225.225,0,0,1-.285.112.239.239,0,0,1-.047-.025",
    transform: "translate(-187.818 -177.829)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107126",
    "data-name": "Trazado 107126",
    d: "M252.686,236.2l-1.408-.97,1.62.616a.2.2,0,0,1,.12.266.224.224,0,0,1-.285.112.23.23,0,0,1-.047-.025",
    transform: "translate(-181.536 -174.22)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107127",
    "data-name": "Trazado 107127",
    d: "M283.387,252.9l-15.228-8.206,15.44,7.853a.2.2,0,0,1,.087.275.224.224,0,0,1-.294.081l0,0",
    transform: "translate(-193.731 -181.226)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107128",
    "data-name": "Trazado 107128",
    d: "M267.7,373.356l-1.638-3.431,2.025,3.246a.2.2,0,0,1-.079.278.226.226,0,0,1-.3-.073.162.162,0,0,1-.011-.02",
    transform: "translate(-192.218 -273.977)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107129",
    "data-name": "Trazado 107129",
    d: "M211.106,262.811l-2.826-5.6,3.213,5.412a.2.2,0,0,1-.085.276.225.225,0,0,1-.3-.079l-.006-.012",
    transform: "translate(-150.472 -190.5)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107130",
    "data-name": "Trazado 107130",
    d: "M261.669,361.721l-.6-1.536.985,1.351a.2.2,0,0,1-.058.284.229.229,0,0,1-.3-.054.209.209,0,0,1-.025-.045",
    transform: "translate(-188.61 -266.763)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107131",
    "data-name": "Trazado 107131",
    d: "M226.536,293.19l-.6-1.536.985,1.351a.2.2,0,0,1-.058.284.229.229,0,0,1-.3-.054.208.208,0,0,1-.025-.045",
    transform: "translate(-163.228 -216.007)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107132",
    "data-name": "Trazado 107132",
    d: "M221.988,284.32l-.6-1.536.985,1.351a.2.2,0,0,1-.058.284.229.229,0,0,1-.3-.054.207.207,0,0,1-.025-.045",
    transform: "translate(-159.942 -209.438)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107133",
    "data-name": "Trazado 107133",
    d: "M238.043,314.714,230.217,300l8.212,14.525a.2.2,0,0,1-.091.274.225.225,0,0,1-.293-.085l0,0",
    transform: "translate(-166.32 -222.191)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107134",
    "data-name": "Trazado 107134",
    d: "M298.326,304.747l-1.119-1.257,1.415.961a.2.2,0,0,1,.049.286.229.229,0,0,1-.306.045.233.233,0,0,1-.04-.035",
    transform: "translate(-214.717 -224.773)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107135",
    "data-name": "Trazado 107135",
    d: "M241.458,249.488l-20-18.081,20.3,17.787a.194.194,0,0,1,.01.287.228.228,0,0,1-.307.009l0,0",
    transform: "translate(-159.989 -171.386)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107136",
    "data-name": "Trazado 107136",
    d: "M261.156,320.779l-.76-1.473,1.124,1.253a.2.2,0,0,1-.027.288.229.229,0,0,1-.308-.025.22.22,0,0,1-.029-.043",
    transform: "translate(-188.123 -236.487)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107137",
    "data-name": "Trazado 107137",
    d: "M243.805,294.331l-5.228-7.635,5.589,7.409a.2.2,0,0,1-.052.283.227.227,0,0,1-.3-.049l-.006-.007",
    transform: "translate(-172.36 -212.335)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107138",
    "data-name": "Trazado 107138",
    d: "M190.253,290.418l-3.824-18.742,4.25,18.661a.2.2,0,0,1-.167.241.218.218,0,0,1-.258-.156v0",
    transform: "translate(-134.686 -201.211)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107139",
    "data-name": "Trazado 107139",
    d: "M235.41,352.158l-.465-1.576.866,1.421a.2.2,0,0,1-.082.279.227.227,0,0,1-.3-.076.2.2,0,0,1-.021-.047",
    transform: "translate(-169.736 -259.651)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107140",
    "data-name": "Trazado 107140",
    d: "M209.742,286.554l-8.769-21.134,9.172,20.984a.2.2,0,0,1-.119.264.223.223,0,0,1-.283-.111v0",
    transform: "translate(-145.193 -196.577)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107141",
    "data-name": "Trazado 107141",
    d: "M300.225,218.783l-1.709-.35,1.748-.054a.213.213,0,0,1,.226.2.211.211,0,0,1-.211.211.244.244,0,0,1-.054,0",
    transform: "translate(-215.663 -161.737)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107142",
    "data-name": "Trazado 107142",
    d: "M248.647,213.544l-17.482-1.9,17.527,1.5a.207.207,0,0,1,.2.22.213.213,0,0,1-.236.184h-.006",
    transform: "translate(-167.005 -156.747)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107143",
    "data-name": "Trazado 107143",
    d: "M307.994,302.372a.789.789,0,1,1,.787.735.762.762,0,0,1-.787-.735",
    transform: "translate(-222.51 -223.401)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107144",
    "data-name": "Trazado 107144",
    d: "M210.886,341.68a.788.788,0,1,1,.787.735.762.762,0,0,1-.787-.735",
    transform: "translate(-152.354 -252.513)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107145",
    "data-name": "Trazado 107145",
    d: "M311.415,316.762a.518.518,0,1,1,.517.483.5.5,0,0,1-.517-.483",
    transform: "translate(-224.982 -234.245)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107146",
    "data-name": "Trazado 107146",
    d: "M219.526,352.091a.518.518,0,1,1,.517.483.5.5,0,0,1-.517-.483",
    transform: "translate(-158.596 -260.411)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107147",
    "data-name": "Trazado 107147",
    d: "M276.521,234.769a.518.518,0,1,1,.517.483.5.5,0,0,1-.517-.483",
    transform: "translate(-199.772 -173.519)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107148",
    "data-name": "Trazado 107148",
    d: "M268.362,306.387a.518.518,0,1,1,.517.483.5.5,0,0,1-.517-.483",
    transform: "translate(-193.878 -226.561)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107149",
    "data-name": "Trazado 107149",
    d: "M249.65,280.909l-5.37-5.779,5.69,5.5a.194.194,0,0,1-.005.287.228.228,0,0,1-.307,0l-.007-.008",
    transform: "translate(-176.48 -203.769)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107150",
    "data-name": "Trazado 107150",
    d: "M75.18,333.03l-1.5-.1-.763-1.21-.563,1.3-1.467.3,1.15.9-.144,1.4,1.275-.743,1.378.56-.362-1.363Z",
    transform: "translate(-51.213 -245.682)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107151",
    "data-name": "Trazado 107151",
    d: "M78.306,328.6l2.782-2.92L79.053,329.1Z",
    transform: "translate(-56.572 -241.207)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107152",
    "data-name": "Trazado 107152",
    d: "M.115,291.774,3.661,290,.34,292.121a.227.227,0,0,1-.3-.053.2.2,0,0,1,.057-.282l.02-.011",
    transform: "translate(0 -214.784)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107153",
    "data-name": "Trazado 107153",
    d: "M100.428,227.4l5.773-3.032-5.548,3.379a.227.227,0,0,1-.3-.059.2.2,0,0,1,.063-.281l.012-.007",
    transform: "translate(-72.474 -166.17)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107154",
    "data-name": "Trazado 107154",
    d: "M16.459,285l1.6-.667-1.372,1.014a.229.229,0,0,1-.307-.033.2.2,0,0,1,.036-.287.236.236,0,0,1,.046-.026",
    transform: "translate(-11.798 -210.583)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107155",
    "data-name": "Trazado 107155",
    d: "M82.324,245.088l1.6-.667-1.372,1.014a.23.23,0,0,1-.307-.033.2.2,0,0,1,.036-.287.225.225,0,0,1,.046-.026",
    transform: "translate(-59.382 -181.025)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107156",
    "data-name": "Trazado 107156",
    d: "M90.85,239.921l1.6-.667-1.372,1.014a.229.229,0,0,1-.307-.033.2.2,0,0,1,.036-.287.239.239,0,0,1,.046-.026",
    transform: "translate(-65.541 -177.198)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107157",
    "data-name": "Trazado 107157",
    d: "M25.546,257.622l15.145-8.339-14.92,8.686a.226.226,0,0,1-.3-.065.2.2,0,0,1,.069-.279l0,0",
    transform: "translate(-18.378 -184.626)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107158",
    "data-name": "Trazado 107158",
    d: "M80.781,371.637l2.025-3.246-1.638,3.431a.224.224,0,0,1-.287.1.2.2,0,0,1-.11-.268l.011-.019",
    transform: "translate(-58.338 -272.841)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107159",
    "data-name": "Trazado 107159",
    d: "M134.291,261.092l3.212-5.411-2.826,5.6a.224.224,0,0,1-.289.1.2.2,0,0,1-.1-.27l.006-.012",
    transform: "translate(-96.999 -189.364)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107160",
    "data-name": "Trazado 107160",
    d: "M89.5,360l.985-1.352-.6,1.537a.224.224,0,0,1-.281.122A.2.2,0,0,1,89.5,360",
    transform: "translate(-64.63 -265.626)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107161",
    "data-name": "Trazado 107161",
    d: "M124.632,291.471l.985-1.351-.6,1.536a.224.224,0,0,1-.281.122.2.2,0,0,1-.106-.307",
    transform: "translate(-90.013 -214.871)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107162",
    "data-name": "Trazado 107162",
    d: "M129.18,282.6l.985-1.351-.6,1.536a.223.223,0,0,1-.281.122.2.2,0,0,1-.106-.307",
    transform: "translate(-93.299 -208.301)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107163",
    "data-name": "Trazado 107163",
    d: "M94.346,312.994l8.212-14.524-7.826,14.71a.225.225,0,0,1-.291.091.2.2,0,0,1-.1-.272l0,0",
    transform: "translate(-68.142 -221.055)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107164",
    "data-name": "Trazado 107164",
    d: "M176.217,402.08l.118-3.756.315,3.746a.208.208,0,0,1-.2.218.213.213,0,0,1-.234-.187.2.2,0,0,1,0-.022",
    transform: "translate(-127.308 -295.01)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107165",
    "data-name": "Trazado 107165",
    d: "M173.345,277.891l.055-6.188.379,6.179a.209.209,0,0,1-.2.214.213.213,0,0,1-.229-.191v-.013",
    transform: "translate(-125.233 -201.231)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107166",
    "data-name": "Trazado 107166",
    d: "M175.746,389.008l.174-1.627.26,1.617a.207.207,0,0,1-.184.233.217.217,0,0,1-.249-.172.206.206,0,0,1,0-.051",
    transform: "translate(-126.967 -286.905)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107167",
    "data-name": "Trazado 107167",
    d: "M173.858,312.02l.175-1.627.26,1.617a.207.207,0,0,1-.184.232.217.217,0,0,1-.249-.172.193.193,0,0,1,0-.051",
    transform: "translate(-125.603 -229.886)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107168",
    "data-name": "Trazado 107168",
    d: "M173.615,302.055l.174-1.626.26,1.617a.207.207,0,0,1-.184.232.217.217,0,0,1-.249-.172.208.208,0,0,1,0-.051",
    transform: "translate(-125.427 -222.505)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107169",
    "data-name": "Trazado 107169",
    d: "M174.933,336.2l-.214-16.426.648,16.416a.208.208,0,0,1-.209.21.212.212,0,0,1-.225-.2V336.2",
    transform: "translate(-126.226 -236.833)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107170",
    "data-name": "Trazado 107170",
    d: "M51.677,302.918l1.415-.961-1.119,1.257a.229.229,0,0,1-.308.026.2.2,0,0,1-.028-.288.234.234,0,0,1,.04-.034",
    transform: "translate(-37.269 -223.638)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107171",
    "data-name": "Trazado 107171",
    d: "M59.43,247.66l20.3-17.787-20,18.081a.228.228,0,0,1-.307,0,.193.193,0,0,1,.005-.287l0,0",
    transform: "translate(-42.886 -170.25)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107172",
    "data-name": "Trazado 107172",
    d: "M89.637,319.026l1.124-1.253L90,319.246a.225.225,0,0,1-.292.1.2.2,0,0,1-.1-.273.2.2,0,0,1,.029-.043",
    transform: "translate(-64.721 -235.351)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107173",
    "data-name": "Trazado 107173",
    d: "M95.4,292.57l5.588-7.409L95.762,292.8a.226.226,0,0,1-.3.061.2.2,0,0,1-.066-.28l.006-.007",
    transform: "translate(-68.894 -211.199)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107174",
    "data-name": "Trazado 107174",
    d: "M145.16,293.449l6.276-23.307-5.854,23.4a.218.218,0,0,1-.261.151.2.2,0,0,1-.162-.244v0",
    transform: "translate(-104.866 -200.075)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107175",
    "data-name": "Trazado 107175",
    d: "M118.681,351.507l.866-1.421-.465,1.576a.22.22,0,0,1-.269.142.2.2,0,0,1-.153-.251.208.208,0,0,1,.021-.047",
    transform: "translate(-85.72 -259.283)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107176",
    "data-name": "Trazado 107176",
    d: "M122.759,285.907l9.172-20.984-8.769,21.134a.222.222,0,0,1-.281.116.2.2,0,0,1-.124-.262v0",
    transform: "translate(-88.676 -196.209)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107177",
    "data-name": "Trazado 107177",
    d: "M56.438,232.767l1.728-.259-1.606.648a.225.225,0,0,1-.288-.107.2.2,0,0,1,.114-.269.235.235,0,0,1,.052-.014",
    transform: "translate(-40.64 -172.202)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107178",
    "data-name": "Trazado 107178",
    d: "M66.636,221.759l12.252-3.081-12.133,3.471a.22.22,0,0,1-.271-.135.2.2,0,0,1,.144-.253l.007,0",
    transform: "translate(-48.025 -161.959)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107179",
    "data-name": "Trazado 107179",
    d: "M42.128,300.838a.788.788,0,1,0-.787.735.762.762,0,0,0,.787-.735",
    transform: "translate(-29.299 -222.264)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107180",
    "data-name": "Trazado 107180",
    d: "M142.07,366.293a.788.788,0,1,0-.787.735.762.762,0,0,0,.787-.735",
    transform: "translate(-101.502 -270.742)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107181",
    "data-name": "Trazado 107181",
    d: "M40.11,315.227a.519.519,0,1,0-.517.483.5.5,0,0,0,.517-.483",
    transform: "translate(-28.23 -233.108)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107182",
    "data-name": "Trazado 107182",
    d: "M139.668,378.019a.518.518,0,1,0-.517.483.5.5,0,0,0,.517-.483",
    transform: "translate(-100.156 -279.613)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107183",
    "data-name": "Trazado 107183",
    d: "M45.393,236.632a.518.518,0,1,0-.517.484.5.5,0,0,0,.517-.484",
    transform: "translate(-32.047 -174.898)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107184",
    "data-name": "Trazado 107184",
    d: "M83.162,304.852a.519.519,0,1,0-.517.483.5.5,0,0,0,.517-.483",
    transform: "translate(-59.333 -225.424)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107185",
    "data-name": "Trazado 107185",
    d: "M89.276,279.1l5.69-5.5L89.6,279.375a.228.228,0,0,1-.306.02.194.194,0,0,1-.021-.286l.008-.008",
    transform: "translate(-64.453 -202.633)",
    fill: "#e0e8f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ico_Trofeo_Emg",
    transform: "translate(652.25 369.79)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1597",
    "data-name": "Elipse 1597",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(0 49.42)",
    fill: "#7eccc9",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16695",
    "data-name": "Grupo 16695",
    transform: "translate(7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "otorgar",
    transform: "translate(0 11.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105343",
    "data-name": "Trazado 105343",
    d: "M202.86,324.045a17.867,17.867,0,0,0,1.118,3.457,20.84,20.84,0,0,0,2.061,3.62l2.388,3.392h-16.69l2.388-3.392a20.841,20.841,0,0,0,2.061-3.62,17.851,17.851,0,0,0,1.118-3.457",
    transform: "translate(-176.405 -283.263)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105344",
    "data-name": "Trazado 105344",
    d: "M138.9,50.782h-.058A17.452,17.452,0,0,1,121.388,33.33V10h34.961V33.33A17.452,17.452,0,0,1,138.9,50.782Z",
    transform: "translate(-115.191 -10)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105345",
    "data-name": "Trazado 105345",
    d: "M177.125,83.354a11.751,11.751,0,0,1-11.738-11.738V54h23.534V71.616a11.751,11.751,0,0,1-11.738,11.738Z",
    transform: "translate(-153.477 -48.286)",
    fill: "#fce3ed"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_212",
    "data-name": "L\\xEDnea 212",
    x2: 38.807,
    transform: "translate(4.274)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_213",
    "data-name": "L\\xEDnea 213",
    x2: 44.656,
    transform: "translate(1.349 63.891)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_85531",
    "data-name": "Rect\\xE1ngulo 85531",
    width: 38.201,
    height: 12.641,
    transform: "translate(4.577 51.25)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105346",
    "data-name": "Trazado 105346",
    d: "M395.273,64.782l-4.661,4.143V54.285h6.2v7.082A4.569,4.569,0,0,1,395.273,64.782Z",
    transform: "translate(-349.454 -48.534)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105347",
    "data-name": "Trazado 105347",
    d: "M79.867,68.925l-4.661-4.143a4.569,4.569,0,0,1-1.535-3.415V54.285h6.2Z",
    transform: "translate(-73.67 -48.534)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105348",
    "data-name": "Trazado 105348",
    d: "M221.825,126.977l-2.767,1.267a.372.372,0,0,1-.524-.381l.349-3.023-2.06-2.24a.372.372,0,0,1,.2-.616l2.983-.6,1.494-2.651a.372.372,0,0,1,.648,0l1.494,2.651,2.983.6a.372.372,0,0,1,.2.616l-2.06,2.24.349,3.023a.372.372,0,0,1-.524.381Z",
    transform: "translate(-198.148 -104.445)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_214",
    "data-name": "L\\xEDnea 214",
    x2: 10.681,
    transform: "translate(18.337 57.57)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_69_",
    transform: "translate(35.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105334",
    "data-name": "Trazado 105334",
    d: "M328.095,354.631a11.475,11.475,0,1,1,11.475-11.475A11.488,11.488,0,0,1,328.095,354.631Z",
    transform: "translate(-316.62 -331.682)",
    fill: "#b1e0de"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_10",
    "data-name": 10,
    transform: "translate(38.354 14.975)",
    fill: "#3b0310",
    fontSize: 10,
    fontFamily: "Roboto, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+10")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrophy);
export default __webpack_public_path__ + "static/media/icon-trophy.7d134d420058e6ee5f478da33d3ff082.svg";
export { ForwardRef as ReactComponent };